import { createApiService } from './createApiService'

export const articlesAPI = createApiService({
  reducerPath: 'articlesAPI',
  tagTypes: ['Article'],
  endpoints: (build: any) => ({
    getAllArticles: build.mutation({
      query: () => ({
        url: `/article/all`,
        method: 'GET',
      }),
    }),
    getMyArticles: build.mutation({
      query: () => ({
        url: `/article/my`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useGetAllArticlesMutation, useGetMyArticlesMutation } = articlesAPI
